import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGetMerchantValueDatedPaymentsRequest {
  startDate: string;
  endDate: string;
  page: number;
  size: number;
  orderBy: string;
  orderByDesc: boolean;
  filters: Array<any>,
  isExcel: boolean
}

async function GetMerchantValueDatedPayments(
  data: IGetMerchantValueDatedPaymentsRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Reconciliation/ListMerchantValoredPayments", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantValueDatedPayments() {
  return useMutation<any, Error, IGetMerchantValueDatedPaymentsRequest>((variables) =>
    GetMerchantValueDatedPayments(variables)
  );
}
